import React from 'react';
import { FormGroup, Col, ButtonToolbar } from 'react-bootstrap';

const FormActions = ({ horizontal, children, labelCol = 3, valueCol = 9 }) => {
	const buttons = <ButtonToolbar>{children}</ButtonToolbar>;

	if (horizontal) {
		return (
			<FormGroup className='row'>
				<Col smOffset={labelCol} sm={valueCol}>
					{buttons}
				</Col>
			</FormGroup>
		);
	}

	return buttons;
};

export default FormActions;